<template>
  <div class="result-item cursor-pointer" @click="click(obj)">
    <div class="compact-list d-flex gap-4 align-items-center px-3 py-2">
      <img
        v-if="thumbnailUrl"
        :src="thumbnailUrl"
        class="img-fluid rounded w-100 square"
        alt=""
        loading="lazy"
        width="120"
        height="60"
      >
      <div class="d-flex flex-column flex-grow-1">
        <p class="mb-0 result-title"><strong>{{ name }}</strong></p>
        <p class="m-0 text-muted">
          <small>{{ measurementPreference.smallUnitFormatter(distanceMeters, true) }}</small>
          <small v-if="elevationGainMeters > 0">
            <span class="mx-1">&middot;</span> {{ difficulty }}
             {{ measurementPreference.smallUnitFormatter(elevationGainMeters, false) }} ↑
          </small>
          <small v-if="difficulty">
            <span class="mx-1">&middot;</span> {{ difficulty }}
          </small>
        </p>
        <p v-if="parentHikes && parentHikes.length > 0" class="m-0 text-muted parent-hikes">
          <small>Used in: {{ parentHikeNames }}</small>
        </p>
      </div>
      <span class="material-icons add-hover" @click.stop="click(obj)">add_circle</span>
    </div>
    <hr class="my-2">
  </div>
</template>

<script>
import { MeasurementPrefUtility } from '../../utils/helpers/MeasurementPref.ts';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    distanceMeters: {
      type: Number,
      default: 0,
    },
    elevationGainMeters: {
      type: Number,
      default: 0,
    },
    difficulty: {
      type: String,
      default: '',
    },
    thumbnailUrl: {
      type: String,
      default: '',
    },
    obj: {
      type: Object,
      default: {},
    },
    click: {
      type: Function,
      default: () => {},
    },
    parentHikes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      measurementPreference: MeasurementPrefUtility.preference(),
    };
  },
  computed: {
    parentHikeNames() {
      if (!this.parentHikes || this.parentHikes.length === 0) return '';
      return this.parentHikes.map(hike => hike.name).join(', ');
    },
  },
};
</script>

<style scoped>
  .result-title {
    max-width: 260px;
  }

  .result-item{
    cursor: pointer;
  }

  .add-hover:hover{
    color: var(--yellow);
  }

  .parent-hikes {
    font-size: 0.85em;
    opacity: 0.8;
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
